import * as SecureStore from 'expo-secure-store'
import { Platform } from 'react-native'
import { storageMMKV } from './storageMMKV'

const ACCESS_TOKEN_KEY = 'accessToken'
const REFRESH_TOKEN_KEY = 'refreshToken'

const isWeb = Platform.OS === 'web'

export const secureTokenStore = {
  getAccessToken(): string | null {
    return storageMMKV.getString(ACCESS_TOKEN_KEY) || null
  },

  getRefreshToken(): string | null {
    return storageMMKV.getString(REFRESH_TOKEN_KEY) || null
  },

  async setTokens(accessToken: string, refreshToken: string): Promise<void> {
    storageMMKV.set(ACCESS_TOKEN_KEY, accessToken)
    storageMMKV.set(REFRESH_TOKEN_KEY, refreshToken)
    if (!isWeb) {
      await SecureStore.setItemAsync(REFRESH_TOKEN_KEY, refreshToken)
    }
  },

  async clearTokens(): Promise<void> {
    storageMMKV.delete(ACCESS_TOKEN_KEY)
    storageMMKV.delete(REFRESH_TOKEN_KEY)
    if (!isWeb) {
      await SecureStore.deleteItemAsync(REFRESH_TOKEN_KEY).catch(() => {})
    }
  },

  async hydrateFromSecureStore(): Promise<void> {
    if (isWeb) return
    const refreshToken = await SecureStore.getItemAsync(REFRESH_TOKEN_KEY)
    if (refreshToken) storageMMKV.set(REFRESH_TOKEN_KEY, refreshToken)
  },
}
